import * as tslib_1 from "tslib";
import { ElemModel } from '../elem';
var HtmlModel = (function (_super) {
    tslib_1.__extends(HtmlModel, _super);
    function HtmlModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HtmlModel;
}(ElemModel));
export { HtmlModel };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaHRtbC1tb2RlbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImh0bWwtbW9kZWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sRUFBQyxTQUFTLEVBQUMsTUFBTSxTQUFTLENBQUM7QUFFbEM7SUFBK0IscUNBQVM7SUFBeEM7O0lBRUEsQ0FBQztJQUFELGdCQUFDO0FBQUQsQ0FBQyxBQUZELENBQStCLFNBQVMsR0FFdkMifQ==